<template>
  <div class="brochures">
    <h1>Cover Letter</h1>
    <div class="box mb-5">
      <form class="form" v-on:submit.prevent="updateBrochureCoverLetter">
        <fieldset>
          <div class="form-wrap">
            <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(100% - 1rem);">
              <ckeditor :editor="editor" v-model="coverLetterContent" :config="editorConfig"></ckeditor>
            </div>
            <div class="form-submit-inline">
              <button type="submit" class="button"><span>Save Cover Letter</span></button>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
    <h1>Brochures</h1>
		<div class="box">
				<form class="form" v-on:submit.prevent="addBrochure">
					<fieldset>
						<div class="form-wrap">
							<div>
								<label for="name">Brochure Name</label>
								<input id="name" name="name" v-model="newBrochure.brochure_name" type="text" required/>
						</div>
						<div class="form-submit-inline">
							<template v-if="this.$data.loading">
								<button type="submit" class="button" disabled><span>Adding Brochure...</span></button>
							</template>
							<template v-else>
								<button type="submit" class="button"><span>Add Brochure</span></button>
							</template>
						</div>
					</div>
				</fieldset>
			</form>
			<table class="table" cellspacing="0" cellpadding="0">
				<thead v-if="this.$data.brochures.length > 0">
					<tr>
						<th>Brochure Name</th>
						<th>Status</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="brochure of this.$data.brochures" :key="brochure.id">
						<td>{{ brochure.brochure_name }}</td>
            <td>
              <label class="switch">
                <input id="is-active" type="checkbox" v-model="brochure.is_active" @change="changeBrochureStatus($event, brochure.id)">
                <span class="switch__slider"></span>
              </label>
            </td>
						<td class="table-action"><a v-on:click="deleteBrochure(brochure.id)" class="icon icon--delete">Delete</a></td>
					</tr>
				</tbody>
			</table>
		</div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import CKEditor from '@ckeditor/ckeditor5-vue';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  export default {
    name: 'brochures-index',
    components: {
      // Use the <ckeditor> component in this view.
      ckeditor: CKEditor.component
    },
    computed: {
      ...mapGetters(['getLoadStatus']),
    },
    data() {
      return {
        loading: false,
        brochures: [],
        newBrochure: {},
        coverLetterContent: null,
        editor: ClassicEditor,
        editorConfig: {
          toolbar: {
            items: [
              "heading",
              "bold",
              "italic",
              "link",
              "bulletedList",
              "numberedList",
              // "imageUpload",
              "blockQuote",
              "insertTable",
              // "mediaEmbed",
              "undo",
              "redo",
            ],
          },
        }
      }
    },
    created() {
      this.getBrochures()
      this.getBrochuresCoverLetter()
    },
    methods: {
      getBrochures() {
        this.$store.dispatch('setLoadStatus')
        fetch( this.$api + 'brochures', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch('setLoadStatus')
          this.$data.brochures = response.data
        })
      },
      addBrochure() {
        this.$data.loading = true
        fetch(this.$api + 'brochures', {
          method: 'POST',
          body: JSON.stringify(this.newBrochure),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getBrochures()
          this.newBrochure = {}
          this.$data.loading = false
        })
      },
      deleteBrochure(data) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'brochures/' + data + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.success == true) {
            this.getBrochures()
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            })
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            })
          }
          this.$store.dispatch('setLoadStatus')
        })
      },
      getBrochuresCoverLetter() {
        this.$store.dispatch('setLoadStatus')
        fetch( this.$api + 'brochures/cover-letter', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch('setLoadStatus')
          this.coverLetterContent = response.data
        })
      },
      updateBrochureCoverLetter() {
        this.$data.loading = true
        fetch(this.$api + 'brochures/cover-letter', {
          method: 'POST',
          body: JSON.stringify({
           'content': this.coverLetterContent,
           'type': 'brochure_cover_letter_content'
          }),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getBrochuresCoverLetter()
          this.$data.loading = false
        })
      },
      changeBrochureStatus(event, brochureId) {
        this.$data.loading = true
        fetch(this.$api + 'brochures/' + brochureId, {
          method: 'POST',
          body: JSON.stringify({
           'is_active': event.target.checked
          }),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$data.loading = false
        })
      }
    }
  }
</script>
